<template>
  <v-container bg fill-height grid-list-md text-xs-center>
    <v-row align="center" justify="center">
      <v-card width="40%" class="elevation-20" style="border-radius: 10px">
        <v-card-text>
          <v-col align="center">
            <v-container class="ml-5">
              <v-row justify="start" class="ml-3">
                <span class="headline font-weight-bold black--text">Log In</span>
              </v-row>
              <v-row justify="start" class="ml-3 mt-0">
                <span>You need to log in first to vote or submit an Idea.</span>
              </v-row>
            </v-container>
            <v-container fluid class="mt-5">
              <!-- Form -->
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-col cols="12">
                  <v-row justify="center" class="mx-5">
                    <v-text-field
                      v-model="userName"
                      prepend-inner-icon="mdi-account-outline"
                      label="User Name"
                      :rules="[value => !!value || 'Required.', v => (v || '' ).length >= 4 || 'Username must be atleast 4 characters or more', v => (v || '' ).length <= 20 || 'Username must be atmost 20 characters or less']"
                      color="black"
                      placeholder="someLevel"
                      outlined
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row justify="center" class="mx-5">
                    <v-text-field
                      v-model="password"
                      prepend-inner-icon="mdi-lock-outline"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[value => !!value || 'Required.', v => v.length >= 8 || 'Min 8 characters']"
                      :type="show1 ? 'text' : 'password'"
                      name="input-10-1"
                      label="Password"
                      hint="At least 8 characters"
                      counter
                      color="black"
                      @keyup.enter="logInButton"
                      @click:append="show1 = !show1"
                      required
                      outlined
                    ></v-text-field>
                  </v-row>
                </v-col>
                <div class="mb-5">
                  <v-btn
                    :disabled="!valid"
                    rounded
                    outlined
                    color="primary"
                    class="elevation-15"
                    @click="logInButton"
                  >
                    <span class="mx-4 subheading">Log In</span>
                  </v-btn>
                </div>
              </v-form>
              <!--  -->
              <v-container fluid justify="end" align="end">
                <v-row justify="end" align="end" class="mt-5">
                  <span>Not Registered, yet?</span>
                  <span class="primary--text ml-2" @click="signUp" style="cursor: pointer">SignUp</span>
                </v-row>
              </v-container>
            </v-container>
          </v-col>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      show1: false,
      valid: true,
      userName: "",
      password: ""
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    goToHomePage() {
      if (this.$refs.form.validate()) {
        this.$router.push("/home");
      }
    },
    signUp() {
      this.$router.push("/signUp");
    },
    logInButton() {
      if (this.$refs.form.validate()) {
        this.login({ username: this.userName, password: this.password });
      }
    }
  }
};
</script>